export default __webpack_public_path__ + "static/media/githubLight.34f897e0.svg";